var map = {
	"./basketball.webp": 1688,
	"./bti-img.webp": 1689,
	"./bti-title-cn.webp": 1690,
	"./bti-title-en.webp": 1691,
	"./cup.webp": 1692,
	"./football.webp": 1693,
	"./im-img.webp": 1694,
	"./im-title-cn.webp": 1695,
	"./im-title-en.webp": 1696,
	"./sb-img.webp": 1697,
	"./sb-title-cn.webp": 1698,
	"./sb-title-en.webp": 1699,
	"./sbo-img.webp": 1700,
	"./sbo-title-cn.webp": 1701,
	"./sbo-title-en.webp": 1702,
	"./sport-bg.webp": 1703,
	"./sport-ctg.webp": 1704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;